<template>
<footer class="footer"
  :class="{ 
    footerEspecial: route.path === '/Categorias',
    footerMarcas: route.path === '/Marcas',
    footerSephoraSale: route.path === '/SephoraSale',
    footerSets: route.path === '/Sets',
    footerMaquillaje: route.path === '/Maquillaje',
    footerUbicaciones: route.path === '/Ubicaciones'}">

  <div class="pg-footer">
    <footer class="footer">
      <svg class="footer-wave-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 100" preserveAspectRatio="none">
        <path class="footer-wave-path" d="M851.8,100c125,0,288.3-45,348.2-64V0H0v44c3.7-1,7.3-1.9,11-2.9C80.7,22,151.7,10.8,223.5,6.3C276.7,2.9,330,4,383,9.8 c52.2,5.7,103.3,16.2,153.4,32.8C623.9,71.3,726.8,100,851.8,100z"></path>
      </svg>

      <div class="footer-content">
        <div class="footer-content-column">
          <div class="footer-logo">
            <a class="footer-logo-link" href="#">
              <img class="logofooter" src="@/assets/evermore_beauty_store/logo/ebs_logo_v2.png"  alt="Hero">
            </a>
          </div>

          <div class="footer-menu">
            <!--<h2 class="footer-menu-name" style="font-family: 'Magistral_Bold' ;"> Nosotras </h2> -->
            <p class="footer-txt-ebs"> <br>Tu destino de beauty & lifestyle <br> desde 2024. <br> Descubre maquillaje, skincare, <br> moda y los productos más virales. </p>

          </div>
          
        </div>


        <div class="footer-content-column">
          <div class="footer-menu">
            <h2 class="footer-menu-name"> Categorias</h2>
            <ul id="menu-company" class="footer-menu-list">
              <li class="menu-item menu-item-type-post_type menu-item-object-page">
                <router-link to="/Maquillaje">Maquillaje</router-link>
              </li>
              <li class="menu-item menu-item-type-post_type menu-item-object-page">
                <router-link to="/SephoraSale">Sephora Sale</router-link>
              </li>
              <li class="menu-item menu-item-type-post_type menu-item-object-page">
                <router-link to="/SephoraSale">Sets Holidays</router-link>
              </li>
              <li class="menu-item menu-item-type-post_type menu-item-object-page">
                <router-link to="/SephoraSale">Ver por marca</router-link>
              </li>

              
              <!--
              <li class="menu-item menu-item-type-taxonomy menu-item-object-category">
                <a href="#">Skincare</a>
              </li>
              <li class="menu-item menu-item-type-post_type menu-item-object-page">
                <a href="#">Lifestyle</a>
              </li>
              <li class="menu-item menu-item-type-post_type menu-item-object-page">
                <a href="#">Caballeros</a>
              </li>
              <li class="menu-item menu-item-type-taxonomy menu-item-object-category">
                <a href="#">Gifts & Sets</a>
              </li>
              <li class="menu-item menu-item-type-post_type menu-item-object-page">
                <a href="#">Perfumes</a>
              </li>
              <li class="menu-item menu-item-type-post_type menu-item-object-page">
                <a href="#">Snacks</a>
              </li>
-->
              
            </ul>
          </div>
         
        </div>


      
        <div class="footer-content-column">
          <div class="footer-menu">
            <h2 class="footer-menu-name"> LEGALES </h2>
            <ul id="menu-get-started" class="footer-menu-list">
              <li class="menu-item menu-item-type-post_type menu-item-object-product">
                <a href="/legales/terminos-condiciones-evermorebeauty.pdf" target="_blank" rel="noopener"> Términos & Condiciones </a>
              </li>
              <li class="menu-item menu-item-type-post_type menu-item-object-product">
                <a href="/legales/dinamicas_compra_evermorebeauty.pdf" target="_blank" rel="noopener" >Dinámicas de compra</a>
              </li>
              <li class="menu-item menu-item-type-post_type menu-item-object-product">
                <a href="#">Politicas de cancelación</a>
              </li>
              <!--<li class="menu-item menu-item-type-post_type menu-item-object-product">
                <a href="#">Preguntas frec</a>
              </li>-->
            </ul>


          </div>
        </div>

        <div class="footer-content-column">
          <div class="footer-call-to-action">
            <h2 class="footer-menu-name"> Visitanos</h2>
            <!-- <p class="footer-call-to-action-description"> Have a support question?</p> 
            <a class="footer-call-to-action-button button" href="#" target="_self"> Harmony C </a>-->
          </div>
          <div class="footer-call-to-action">
            <!--<h2 class="footer-call-to-action-title"> </h2> -->
            <p class="footer-call-to-action-link-wrapper"> Harmony Colectivo </p>
            <p class="footer-call-to-action-link-wrapper"> Mi Roperito </p>
            <p class="footer-call-to-action-link-wrapper"> Aiconic Colectivo </p>

          </div>
        </div>










        

        <div class="footer-social-links"> <svg class="footer-social-amoeba-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 236 54">
            <path class="footer-social-amoeba-path" d="M223.06,43.32c-.77-7.2,1.87-28.47-20-32.53C187.78,8,180.41,18,178.32,20.7s-5.63,10.1-4.07,16.7-.13,15.23-4.06,15.91-8.75-2.9-6.89-7S167.41,36,167.15,33a18.93,18.93,0,0,0-2.64-8.53c-3.44-5.5-8-11.19-19.12-11.19a21.64,21.64,0,0,0-18.31,9.18c-2.08,2.7-5.66,9.6-4.07,16.69s.64,14.32-6.11,13.9S108.35,46.5,112,36.54s-1.89-21.24-4-23.94S96.34,0,85.23,0,57.46,8.84,56.49,24.56s6.92,20.79,7,24.59c.07,2.75-6.43,4.16-12.92,2.38s-4-10.75-3.46-12.38c1.85-6.6-2-14-4.08-16.69a21.62,21.62,0,0,0-18.3-9.18C13.62,13.28,9.06,19,5.62,24.47A18.81,18.81,0,0,0,3,33a21.85,21.85,0,0,0,1.58,9.08,16.58,16.58,0,0,1,1.06,5A6.75,6.75,0,0,1,0,54H236C235.47,54,223.83,50.52,223.06,43.32Z"></path>
          </svg>

          
          <a class="footer-social-link instagram" href="https://www.facebook.com/evermorebeautystore" target="_blank">
            <span class="hidden-link-text">Facebook</span>
             <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve" >
            <g>
	          <path d="M24,12.073c0,5.989-4.394,10.954-10.13,11.855v-8.363h2.789l0.531-3.46H13.87V9.86c0-0.947,0.464-1.869,1.95-1.869h1.509   V5.045c0,0-1.37-0.234-2.679-0.234c-2.734,0-4.52,1.657-4.52,4.656v2.637H7.091v3.46h3.039v8.363C4.395,23.025,0,18.061,0,12.073   c0-6.627,5.373-12,12-12S24,5.445,24,12.073z"/>
            </g>
          </svg>
          </a>


          
          <a class="footer-social-link facebook" href="https://www.instagram.com/evermore_beauty_store/" target="_blank">
            <span class="hidden-link-text">Instagram </span>
            <svg xmlns="http://www.w3.org/2000/svg" id="Capa_39" data-name="Capa 39" viewBox="0 0 24 24">
              <path d="m14.502,11.986c0,1.431-1.16,2.591-2.591,2.591s-2.59-1.16-2.59-2.591,1.16-2.591,2.59-2.591,2.591,1.16,2.591,2.591h0Zm0,0"/>
              <path d="m12,0h0C5.373,0,0,5.373,0,12h0c0,6.627,5.373,12,12,12h0c6.627,0,12-5.373,12-12h0C24,5.373,18.627,0,12,0Zm7.637,15.19c-.037.827-.169,1.392-.361,1.886-.199.511-.465.945-.897,1.377-.432.432-.866.698-1.376.896-.494.192-1.06.323-1.887.361-.829.038-1.094.047-3.205.047s-2.375-.009-3.204-.047c-.827-.038-1.392-.169-1.887-.361-.511-.198-.944-.465-1.377-.896-.432-.432-.698-.866-.897-1.377-.192-.494-.323-1.059-.361-1.886-.038-.829-.047-1.094-.047-3.205s.009-2.375.047-3.204c.038-.827.169-1.392.361-1.887.199-.511.465-.944.897-1.376s.866-.698,1.377-.897c.494-.192,1.06-.323,1.887-.361.829-.038,1.094-.047,3.204-.047s2.376.009,3.205.047c.827.037,1.392.169,1.887.361.511.198.944.465,1.376.897.432.432.698.866.897,1.376.192.494.323,1.06.361,1.887.038.829.047,1.093.047,3.204s-.009,2.375-.047,3.205h0Zm-1.666-7.788c-.141-.363-.309-.622-.582-.894-.272-.272-.531-.441-.894-.582-.274-.106-.685-.233-1.443-.267-.82-.038-1.066-.045-3.141-.045s-2.321.008-3.141.045c-.757.034-1.169.161-1.443.267-.363.141-.622.309-.894.582-.272.272-.441.531-.582.894-.106.274-.233.685-.267,1.443-.038.819-.045,1.065-.045,3.141s.008,2.321.045,3.141c.035.757.161,1.169.267,1.443.141.363.309.622.582.894.272.272.531.44.894.581.274.107.685.233,1.443.268.819.038,1.065.045,3.141.045s2.322-.008,3.141-.045c.758-.035,1.169-.161,1.443-.268.363-.141.622-.309.894-.581s.441-.531.582-.894c.106-.274.233-.685.267-1.443.038-.82.046-1.066.046-3.141s-.008-2.321-.046-3.141c-.035-.758-.161-1.169-.267-1.443h0Zm-6.059,8.574c-2.204,0-3.991-1.787-3.991-3.991s1.787-3.991,3.991-3.991,3.991,1.787,3.991,3.991-1.787,3.991-3.991,3.991h0Zm4.149-7.207c-.515,0-.933-.417-.933-.932s.417-.933.933-.933.933.418.933.933-.418.932-.933.932h0Zm0,0"/>
            </svg>
          </a>


          
          <a class="footer-social-link tiktok" href="https://www.tiktok.com/@evermore_beauty_store" target="_blank">
            <span class="hidden-link-text">Tik Tok</span>
            <svg xmlns="http://www.w3.org/2000/svg" id="Capa_34" data-name="Capa 34" viewBox="0 0 24 24">
              <path d="m12,0C5.373,0,0,5.373,0,12s5.373,12,12,12,12-5.373,12-12S18.627,0,12,0h0Zm7.439,10.483c-1.52,0-2.93-.486-4.081-1.312v5.961c0,2.977-2.422,5.399-5.399,5.399-1.151,0-2.217-.363-3.094-.978-1.393-.978-2.305-2.594-2.305-4.421,0-2.977,2.422-5.399,5.399-5.399.247,0,.489.02.727.053v2.994c-.23-.072-.474-.114-.727-.114-1.36,0-2.466,1.106-2.466,2.466,0,.947.537,1.769,1.322,2.183.342.18.731.283,1.144.283,1.329,0,2.412-1.057,2.461-2.373l.005-11.756h2.933c0,.254.025.503.069.744.207,1.117.87,2.077,1.789,2.676.64.418,1.403.661,2.222.661v2.933Zm0,0"/>
            </svg>
          </a>



          <a class="footer-social-link google" href="#" target="_blank">
            <span class="hidden-link-text">x</span>
            <svg xmlns="http://www.w3.org/2000/svg" id="Capa_16" data-name="Capa 16" viewBox="0 0 24 24">
              <path class="cls-1" d="m12,0C5.373,0,0,5.373,0,12s5.373,12,12,12,12-5.373,12-12S18.627,0,12,0Zm8,12c0,4.411-3.589,8-8,8s-8-3.589-8-8S7.589,4,12,4c1.782,0,3.468.573,4.876,1.658l-1.859,2.415c-.871-.671-1.914-1.025-3.017-1.025-2.731,0-4.952,2.222-4.952,4.952s2.222,4.952,4.952,4.952c2.199,0,4.068-1.441,4.713-3.429h-4.713v-3.048h8v1.524Z"/>
            </svg>
          </a>

        </div>
      </div>
      <div class="footer-copyright">
        <div class="footer-copyright-wrapper">
          <p class="footer-copyright-text">
            <a class="footer-copyright-link" href="#" target="_self"> ©2026 Evermore Beauty Store | Diseñado por: montserrathdezm | Todos los derechos reservados. </a>
          </p>
        </div>
      </div>
    </footer>
  </div>
</footer>
</template>


<script setup>
  import { useRoute } from 'vue-router'
  const route = useRoute()
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
a {
  color: #fff;
  text-decoration: none;
}
.pg-footer {
  font-family: 'Roboto', sans-serif;
}

.logofooter{
  width: 70%;
}

.footer {
    background-color: #04012f;
    color: #fff;
}

.footer-wave-svg {
    background-color: transparent;
    display: block;
    height: 30px;
    position: relative;
    top: -1px;
    width: 100%;
}
.footer-wave-path {
    fill: #11146d;
}

.footer-txt-ebs{
  font-size: 15px;
  color: #8dd7fc;
  font-family: sans-serif;
}

.footerEspecial .footer-wave-path {
  fill: #8dd7fc;
}
.footerMarcas .footer-wave-path {
  fill: #bdecff;
}
.footerSephoraSale .footer-wave-path {
  fill: #bdecff;
}
.footerSets .footer-wave-path {
  fill: #bdecff;
}
.footerMaquillaje .footer-wave-path {
  fill: #bdecff;
}

.footer-content {
    margin-left: auto;
    margin-right: auto;
    max-width: 1230px;
    padding: 40px 15px 450px;
    position: relative;
}

.footer-content-column {
    box-sizing: border-box;
    float: left;
    padding-left: 15px;
    padding-right: 15px;
    width: 100%;
    color: #fff;
}

.footer-content-column ul li a {
  color: #fff;
  text-decoration: none;
}

.footer-logo-link {
    display: inline-block;
}
.footer-menu {
    margin-top: 30px;
}
.footer-menu-name {
    font-family: "Magistral_Bold";
    color: #8dd7fc;
    font-size: 19px;
    font-weight: 900;
    letter-spacing: .1em;
    line-height: 18px;
    margin-bottom: 0;
    margin-top: 0;
    text-transform: uppercase;
}
.footer-menu-list {
    list-style: none;
    margin-bottom: 0;
    margin-top: 10px;
    padding-left: 0;
}
.footer-menu-list li {
    margin-top: 5px;
}
.footer-call-to-action-description {
    color: #fffff2;
    margin-top: 10px;
    margin-bottom: 20px;
}
.footer-call-to-action-button:hover {
    background-color: #fffff2;
    color: #00bef0;
}
.button:last-of-type {
    margin-right: 0;
}
.footer-call-to-action-button {
    background-color: #8dd7fc;
    border-radius: 21px;
    color: #fffff2;
    display: inline-block;
    font-size: 11px;
    font-weight: 900;
    letter-spacing: .1em;
    line-height: 18px;
    padding: 12px 30px;
    margin: 0 10px 10px 0;
    text-decoration: none;
    text-transform: uppercase;
    transition: background-color .2s;
    cursor: pointer;
    position: relative;
}
.footer-call-to-action {
    margin-top: 30px;
}
.footer-call-to-action-title {
    color: #fffff2;
    font-size: 14px;
    font-weight: 900;
    letter-spacing: .1em;
    line-height: 18px;
    margin-bottom: 0;
    margin-top: 0;
    text-transform: uppercase;
}
.footer-call-to-action-link-wrapper {
    margin-bottom: 0;
    margin-top: 10px;
    color: #fff;
    text-decoration: none;
}
.footer-call-to-action-link-wrapper a {
    color: #fff;
    text-decoration: none;
}


.footer-social-links {
    bottom: 0;
    height: 54px;
    position: absolute;
    right: 0;
    width: 236px;
}

.footer-social-amoeba-svg {
    height: 54px;
    left: 0;
    display: block;
    position: absolute;
    top: 0;
    width: 236px;
}

.footer-social-amoeba-path {
    fill: #8dd7fc;
}

.footer-social-link {
    display: block;
    padding: 10px;
    position: absolute;
}
.hidden-link-text {
    position: absolute;
    clip: rect(1px 1px 1px 1px);
    clip: rect(1px,1px,1px,1px);
    -webkit-clip-path: inset(0px 0px 99.9% 99.9%);
    clip-path: inset(0px 0px 99.9% 99.9%);
    overflow: hidden;
    height: 1px;
    width: 1px;
    padding: 0;
    border: 0;
    top: 50%;
}
.footer-social-icon-svg {
    display: block;
}
.footer-social-icon-path {
    fill: #fffff2;
    transition: fill .2s;
}

.footer-social-link.instagram {
    fill: #04012f;
    height: 50px;
    left: 0px;
    top: 8px;
    width: 50px;
}

.footer-social-link.facebook {
    fill: #04012f;
    height: 58px;
    left: 56px;
    top: 1px;
    width: 58px;
}
.footer-social-link.tiktok {
    fill: #04012f;
    height: 51px;
    left: 119px;
    top: 08px;
    width: 51px;
}
.footer-social-link.google {
    fill: #04012f;
    height: 51px;
    left: 172px;
    top: 7px;
    width: 51px;
}
.footer-copyright {
    background-color: #8dd7fc;
    color: #04012f;
    padding: 15px 30px;
  text-align: center;
}

.footer-copyright-wrapper {
    margin-left: auto;
    margin-right: auto;
    max-width: 1200px;
}

.footer-copyright-text {
  color: #04012f;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    margin-bottom: 0;
    margin-top: 0;
}

.footer-copyright-link {
    color: #04012f;
    font-family: "Magistral_Bold";
    text-decoration: none;
    font-size: 1.3rem;
}

.footer-content-column ul li :hover {
    color: #8dd7fc;
    text-decoration: none;
    transition: all 0.5s ease;
    font-size: 2.7rem;
}

/* Media Query For different screens */
@media (min-width:320px) and (max-width:479px)  { /* smartphones, portrait iPhone, portrait 480x320 phones (Android) */
  .footer-content {
    margin-left: auto;
    margin-right: auto;
    max-width: 1230px;
    padding: 40px 15px 1050px;
    position: relative;
  }
}
@media (min-width:480px) and (max-width:599px)  { /* smartphones, Android phones, landscape iPhone */
  .footer-content {
    margin-left: auto;
    margin-right: auto;
    max-width: 1230px;
    padding: 40px 15px 1050px;
    position: relative;
  }
}
@media (min-width:600px) and (max-width: 800px)  { /* portrait tablets, portrait iPad, e-readers (Nook/Kindle), landscape 800x480 phones (Android) */
  .footer-content {
    margin-left: auto;
    margin-right: auto;
    max-width: 1230px;
    padding: 40px 15px 1050px;
    position: relative;
  }
}
@media (min-width:801px)  { /* tablet, landscape iPad, lo-res laptops ands desktops */

}
@media (min-width:1025px) { /* big landscape tablets, laptops, and desktops */

}
@media (min-width:1281px) { /* hi-res laptops and desktops */

}




@media (min-width: 760px) {
  .footer-content {
      margin-left: auto;
      margin-right: auto;
      max-width: 1230px;
      padding: 40px 15px 450px;
      position: relative;
  }

  .footer-wave-svg {
      height: 50px;
  }

  .footer-content-column {
      width: 24.99%;
  }
}
@media (min-width: 568px) {
  /* .footer-content-column {
      width: 49.99%;
  } */
}


</style>
